import { useState } from 'react'
import { useLists } from '@/db/hooks'
import { ListForm, ListRow, sortLists } from '@/kinds/list/components'
import { Button, Empty, PageTitle } from '@/components/ui'
import { AppTabs, NOTES_TABS } from '@/components/AppTabs'

/** Every list in the workspace scope, pinned first. */
export const ListsView = () => {
  const lists = (useLists() ?? []).filter((l) => !l.deleted_at && !l.status.converted_to)
  const [creating, setCreating] = useState(false)
  const sorted = sortLists(lists)
  return (
    <div data-testid="lists">
      <PageTitle
        right={
          <Button variant="primary" onClick={() => setCreating(true)} data-testid="list-new">
            + New list
          </Button>
        }
      >
        Notes
      </PageTitle>
      <AppTabs tabs={NOTES_TABS} label="Notes" />
      {sorted.length === 0 ? (
        <Empty icon="☑">
          Shopping, packing, a routine to tick through. A list is quick to add to and safe for two people to
          work at once.
        </Empty>
      ) : (
        <ul className="group-list" data-testid="lists-list">
          {sorted.map((l) => (
            <ListRow key={l.id} resource={l} />
          ))}
        </ul>
      )}
      {creating && <ListForm onDone={() => setCreating(false)} />}
    </div>
  )
}
